module.exports = __webpack_public_path__ + "static/media/portfolio-img1.e72c2187.jpg";